module.exports = "//docs.gtimg.com/slide/img/img/cursors/text_edge_brush-b61eb4.cur";